import { useEffect, Fragment, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as appActions from "../../../store/actions/app";
import * as claimsActions from "../../../store/actions/claims";
import NoData from "../../shared/ui/no-data/NoData";
import styles from "./Claim.module.css";
import { useParams } from "react-router-dom";

function Claim() {
  const dispatch = useDispatch();
  let claimSummary = useSelector((state) => state.claims.claimSummary);
  let claimantNames = claimSummary ? claimSummary.claimantName.split("; ") : [];
  let isLoading = useSelector((state) => state.app.isLoading);
  const { claimId } = useParams();
 // const [iframeVisible, setIframeVisible] = useState('hidden');//commented out, for Jutro

  useEffect(() => {
    dispatch(appActions.setButtonHeader(false));
    dispatch(claimsActions.setActiveClaim(claimId));
    dispatch(claimsActions.getClaimSummary(claimId));
    //remove getclaimSummary when move to Jutro

    return () => {
      dispatch(appActions.setButtonHeader(true));
    };
  }, [dispatch, isLoading]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.title = `- View Claim #${claimId}`;
  }, [claimId]);

  // const handleEvent = (event) => {
  //   if (event?.data?.type === "JUTRO_READY" && event?.origin === process.env.REACT_APP_JUTRO_URL) {
  //     dispatch(appActions.setLoading(false));
  //     setIframeVisible('visible');
  //   }
  // };

  // useEffect(() => {
  //   dispatch(appActions.setLoading(true));
  //   window.addEventListener('message', handleEvent);

  //   return () => {
  //     window.removeEventListener('message', handleEvent);
  //   };
  // }, [dispatch])
  //above commented out, for Jutro

  return (
    <div className={styles.container}>
     {/* <iframe
        title="Claim Details"
        src={`${process.env.REACT_APP_JUTRO_URL}?claimNumber=${claimId}`}
        className={styles.iframe}
        style={{visibility: iframeVisible}}
        >

      </iframe>*/}
      <div className="formRow">
        <h1 className={styles.header}>Your Claim Summary</h1>
      </div>

      {!isLoading &&
      claimSummary !== null &&
      claimSummary.claimNumber === claimId ? (
        <Fragment>
          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <p>
                <strong>CLAIM : #{claimSummary.claimNumber}</strong>
              </p>
              <p>
                Status : <strong>{claimSummary.status}</strong>
              </p>
              <p>
                Claim Closed Date :{" "}
                <strong>{claimSummary.claimClosedDate}</strong>
              </p>
            </div>
            <div className={styles.cardBody}>
              <div className={styles.cardRow}>
                <span className={styles.title}>Insured</span>{" "}
                {claimSummary.insured}
              </div>
              <div className={styles.cardRow}>
                <span className={styles.title}>Loss Date</span>{" "}
                {claimSummary.lossDate}
              </div>

              {claimantNames.map((name, index) => {
                if (index === 0) {
                  return (
                    <div className={styles.cardRow}>
                      <span className={styles.title}>Claimant Name</span> {name}
                    </div>
                  );
                } else {
                  return (
                    <div className={styles.cardRow}>
                      <span className={styles.title}></span> {name}
                    </div>
                  );
                }
              })}

              <div className={styles.cardRow}>
                <span className={styles.title}>Policy #</span>{" "}
                {claimSummary.policyNumber}
              </div>
              <div className={styles.cardRow}>
                <span className={styles.title}>Policy Period</span>{" "}
                {claimSummary.policyPeriod}
              </div>
              <div className={styles.cardRow}>
                <span className={styles.title}>Accident City, State</span>{" "}
                {claimSummary.accidentCityState}
              </div>
              <div className={styles.cardRow}>
                <span className={styles.title}>Claim Type</span>{" "}
                {claimSummary.claimType}
              </div>
              <div className={styles.cardRow}>
                <span className={styles.title}>Claim Description</span>{" "}
                {claimSummary.claimDescription}
              </div>
            </div>
          </div>

          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <p>
                <strong>CLAIM SPECIALIST</strong>
              </p>
            </div>
            <div className={styles.cardBody}>
              <div className={styles.cardRow}>
                <span className={styles.title}>Name</span>
                {claimSummary.claimSpecialistName}
              </div>
              <div className={styles.cardRow}>
                <span className={styles.title}>Office Address</span>
                {claimSummary.claimSpecialistOfficeAddress}
              </div>
              <div className={styles.cardRow}>
                <span className={styles.title}>Telephone</span>
                {claimSummary.claimSpecialistTelephone}
              </div>
              <div className={styles.cardRow}>
                <span className={styles.title}>Email</span>
                {claimSummary.claimSpecialistEmail}
              </div>
              <div className={styles.cardRow}>
                <span className={styles.title}>Fax</span>
                {claimSummary.claimSpecialistFax}
              </div>
            </div>
          </div>

          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <p>
                <strong>PAYMENT HISTORY</strong>
              </p>
            </div>
            <div className={styles.cardBody}>
              <p>
                {parseFloat(claimSummary.totalAmount)
                  ? `Total $${ parseFloat(claimSummary.totalAmount).toFixed(2)}`
                  : "No payment history found"}
              </p>
            </div>
          </div>
        </Fragment>
      ) : (
        <NoData message="NO CLAIM DATA" />
      )}
    </div>
  );
}

export default Claim;
